<template>
  <div class="poi">
    插箱
  </div>
</template>

<script>
// import cfg from "./config.js";
export default {
  props: ['battryId'],//电池插箱id
  methods: {
  },
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/webgl/ui/pop/popcontent.vue